import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

export default function setup() {
  const env = (process.env.REACT_APP_ENVNAME as string);
  const available = (env === 'production' || env === 'beta');
  // const WEB_APP_VERSION = 'TEST@MSCN-1739';

  const sampleRate = 0;
  // if (env === 'production') {
  //   sampleRate = 0.1;
  // } else if (env === 'beta') {
  //   sampleRate = 0;
  // }
  if (available)  {
    Sentry.init({
      release: 'MSCN-WEB-PAY-23.5.0',
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_ENVNAME,
      integrations: [new TracingIntegrations.BrowserTracing()],
      tracesSampleRate: sampleRate,
    });
  }
}
